export const FINANCE_PATH = '/finance'

export const BILLING_PROFILE_TAB_KEYS = {
  COMPANIES: 'companies',
  FUNDING_MANAGERS: 'funding-managers',
} as const

export type BillingProfileTabKey =
  (typeof BILLING_PROFILE_TAB_KEYS)[keyof typeof BILLING_PROFILE_TAB_KEYS]

const BILLING_PROFILES_PATH = `${FINANCE_PATH}/billing-profiles`

/** Companies is the index tab, so it owns the bare path rather than a subpath. */
export const billingProfileTabPath = (key: BillingProfileTabKey): string =>
  key === BILLING_PROFILE_TAB_KEYS.COMPANIES
    ? BILLING_PROFILES_PATH
    : `${BILLING_PROFILES_PATH}/${key}`

/**
 * What a row click must leave alone, since it does something else already.
 * `.ant-dropdown` matters most: antd renders a menu in a portal, but React
 * still bubbles its clicks up to the row.
 */
export const ROW_CONTROL_SELECTOR = [
  'button',
  'a',
  'input',
  'label',
  '.ant-checkbox-wrapper',
  // The whole checkbox cell, so its padding selects rather than opens history.
  '.ant-table-selection-column',
  '.ant-dropdown',
  '.ant-popover',
].join(', ')
